import { render, staticRenderFns } from "./TextareaSimple.vue?vue&type=template&id=76ba1def&"
import script from "./TextareaSimple.vue?vue&type=script&lang=js&"
export * from "./TextareaSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports